<template>
    <div>
        <div class="add-content" @click="add=true" v-if="!add">
            <div class="line"></div>
            <div class="control">
               <i class="fas fa-plus mr-2"></i>Insert Content Block
            </div>
        </div>

        <div v-if="add" class="add-content-selector">
            <div class="has-text-white p-2 pl-4" style="background-color: #336699">
                <div class="is-pulled-left has-text-weight-bold">
                    <i class="fas fa-plus mr-2 "></i>Add Content Block
                </div>
                <div class="is-pulled-right mr-3 is-clickable" @click="add=false">
                    <i class="fas fa-times mr-2"></i>Cancel
                </div>
                <div class="is-clearfix"></div>
            </div>

            <b-tabs :animated="false" >
                <b-tab-item>
                    <template #header>
                        <i class="fad fa-align-left mr-2"></i>Text
                    </template>
                    <ul class="block-list">
                        <li @click="addContent('OneColumnText')"><i class="fad fa-cube mr-3"></i>Single Column Text</li>
                        <li @click="addContent('TwoColumnText')"><i class="fad fa-cube mr-3"></i>Two Column Text</li>
                        <li @click="addContent('ThreeColumnText')"><i class="fad fa-cube mr-3"></i>Three Column Text</li>
                        <li @click="addContent('Message')"><i class="fad fa-cube mr-3"></i>Text Message/Alert</li>
                    </ul>
                </b-tab-item>

                <b-tab-item>
                    <template #header>
                        <i class="fad fa-photo-film-music mr-2"></i>Media
                    </template>
                    <ul class="block-list">
                        <li @click="addContent('Video')"><i class="fad fa-cube mr-3"></i>Library Video</li>
                        <li @click="addContent('PhotoAndText')"><i class="fad fa-cube mr-3"></i>Library Photo & Text</li>
                    </ul>
                </b-tab-item>

                <b-tab-item>
                    <template #header>
                        <i class="fad fa-keyboard mr-2"></i>Input
                    </template>
                    <ul class="block-list">
                        <li @click="addContent('TextField')"><i class="fad fa-cube mr-3"></i>Text Field Question</li>
                        <li @click="addContent('TextArea')"><i class="fad fa-cube mr-3"></i>Text Area Question</li>
                        <li @click="addContent('CheckBox')"><i class="fad fa-cube mr-3"></i>Checkbox/Switch</li>
                        <li @click="addContent('DropdownField')"><i class="fad fa-cube mr-3"></i>Dropdown Select Question</li>
                    </ul>
                </b-tab-item>

                <b-tab-item>
                    <template #header>
                        <i class="fad fa-hand-pointer mr-2"></i>Interactive
                    </template>
                    <ul class="block-list">
                        <li @click="addContent('ExpanderText')"><i class="fad fa-cube mr-3"></i>Expand/Show More Text</li>
                        <li @click="addContent('FlipCards')"><i class="fad fa-cube mr-3"></i>Flip Cards</li>
                        <li @click="addContent('ImageHotspot')"><i class="fad fa-cube mr-3"></i>Image Hotspots</li>
                    </ul>
                </b-tab-item>

                <b-tab-item>
                    <template #header>
                        <i class="fad fa-sparkles mr-2"></i>Special
                    </template>
                    <ul class="block-list">
                        <li @click="addContent('StudyRecordLog')"><i class="fad fa-cube mr-3"></i>Study/Record Log</li>
                        <li @click="addContent('DistrictSchoolField')"><i class="fad fa-cube mr-3"></i>District &amp; School Selector</li>
                    </ul>
                </b-tab-item>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                add: false
            }
        },
        methods: {
            addContent(component) {
                this.$emit('add', component);
                this.add = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .add-content {
        position: relative;
        height: 20px;
        cursor: pointer;
        transition: opacity 300ms;
        min-height: 5px;

        .line {
            height: 1px;
            position: absolute;
            top: 10px;
            left: 0;
            right: 10px;
            border-bottom: 2px dotted #f4f4f4;

        }

        .control {
            position: absolute;
            top: 1px;
            left: 43%;
            display: inline-block;
            font-size: 10px;
            color: white;
            padding: 2px 10px 0 10px;
            border: 1px solid #336699;
            background: #336699;
            border-radius: 20px;
            transition: opacity 300ms;

            opacity: 0;

        }

        &:hover {
            .line {
                border: 1px solid #336699;
            }
            .control {
                opacity: 1;
            }
        }
    }

    .add-content-selector {

        margin-top: 0.8rem;
        border: 2px solid #336699;
        border-radius: 0.5rem;

        ul {
            margin: 0;
            list-style: none;

            li {
                padding: 0.5rem 1rem;
                border: 1px solid #f3f3f3;
                border-radius: 0.3rem;
                cursor: pointer;
                transition: background-color 300ms;
                font-weight: bold;

                i.fa-cube {
                    color: #cacaca;
                }

                &:hover {
                    border: 1px solid #c8c8c8;
                    background-color: #f7f7f7;
                }
            }
        }
    }
</style>

<style lang="scss">
    .add-content-selector {

        ul {
            margin: 0;

            li {
                a {
                    font-size: 0.9rem;
                }
            }

        }
    }
</style>
